import React, { useContext, useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import "./../../styles/AddProduct.css"
import Swal from 'sweetalert2'
import { ImExit } from 'react-icons/im'
import { urlApiServer } from '../../Config/Config'
import LogoComponent from '../LogoComponent'
import CloseButton from '../CloseButton'
import Nav1 from '../Nav/Nav1'
import LoginContext from '../../Context/Logincontext'

let splitImg = []

const EditInventory = (props) => {
    console.log("props: ", props.id)
    const putEditRawMaterial = urlApiServer + "editRawMaterial";
    const urlgetInventoryById = urlApiServer + "getinventorybyid";

    const [id, setId] = useState('')
    const [name, setName] = useState('')
    const [lastNameOne, setLastNameOne] = useState('')
    const [quantity, setQuantity] = useState(null)
    const [outGoingAmount, setOutGoingAmount] = useState();
    const [incomingQuantity, setIncomingQuantity] = useState(null)
    const [typeOfMeasure, setTypeOfMeasure] = useState()
    const [pricePerMeasure, setPricePerMeasure] = useState('')
    const [amount, setAmount] = useState(0)

    const { infoUser, setInfoUser } = useContext(LoginContext)
    const [oldConfig, setOldConfig] = useState("")
    const [logo, setLogo] = useState("")

    useEffect(() => {
        (async function () {

            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json")
            InicioHeaders.append("id", props.id); // Enviar el nombre de la empresa como encabezado
            InicioHeaders.append("company", infoUser.company); // Enviar el nombre de la empresa como encabezado

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            }
            await fetch(urlgetInventoryById, requesoption).then(response => response.json()).then(quotesResponse => {
                console.log("quotesResponse: ", quotesResponse[0])
                setName(quotesResponse[0].nameofmaterial)
                setId(quotesResponse[0].id)
                setQuantity(quotesResponse[0].amount)
                setOutGoingAmount(quotesResponse[0].amount)
                setAmount(quotesResponse[0].amount)
                setPricePerMeasure(quotesResponse[0].pricePerMeasure)
                setTypeOfMeasure(quotesResponse[0].typeOfMeasure)
                // setOldConfig(quotesResponse)
            })
        }())
    }, [])

    useEffect(() => {
        if (oldConfig) {
            const foundConfig = oldConfig.find(obj => obj.empresa === infoUser.company);
            if (foundConfig) {
                const { logo } = foundConfig;
                setLogo(logo);
            }
        }
    }, [oldConfig, infoUser])

    if (logo) {
        splitImg = logo.split("|")
    }

    async function handleAmount(e) {
        const amount = e.target.value;
        setIncomingQuantity(amount);
    }

    async function handleBlur() {
        // Realizar la suma cuando el usuario sale del campo
        // - Number(missingamount)
        const sumOfQuantities = Number(outGoingAmount) + Number(incomingQuantity);
        console.log('sumOfQuantities: ', sumOfQuantities);
        setAmount(sumOfQuantities)
    }

    async function handleName(e) {
        const name = e.target.value.replace(/[^A-Z a-z0-9.]/g, "");
        // if (/^[A-Za-z.\s]+$/.test(name) || name === '') {
        setName(name)
        // }
    }

    async function handleLastNameOne(e) {
        // const lastNameOne = e.target.value.replace(/[^A-Z a-z]/g, "");
        const lastNameOne = e.target.value.replace(/[^A-Z a-z0-9.]/g, "");
        setLastNameOne(lastNameOne)
    }

    async function handleQuantity(e) {
        let value = e.target.value
        // e.target.value = value;
        setQuantity(value);
    }

    async function handleTypeOfMeasure(e) {
        let value = e.target.value
        // e.target.value = value;
        setTypeOfMeasure(value);
    }

    async function handlePrecePerMeasure(e) {
        let value = e.target.value
        // e.target.value = value;
        setPricePerMeasure(value);
    }

    async function uploadInventory() {
        const data = JSON.stringify({
            empresa: infoUser.company,
            id: id,
            nameofmaterial: name,
            amount: amount,
            typeOfMeasure: typeOfMeasure ? typeOfMeasure : 'cantidad',
            pricePerMeasure: pricePerMeasure,
            availability: "Con disponibilidad",
            missingamount: 0
        })

        console.log('JSON.stringify: ', data)

        const registerHeaders = new Headers();
        registerHeaders.append("Content-Type", "application/json")

        const requesoption = {
            method: 'PUT',
            headers: registerHeaders,
            body: data,
            redirect: 'follow'
        }

        await fetch(putEditRawMaterial, requesoption).then(response => response.json())
            .then(dataResponse => {
                if (200 === dataResponse.status) {
                    return Swal.fire({
                        icon: 'success',
                        title: '¡Hecho!',
                        text: dataResponse.msj,
                        allowOutsideClick: false,
                        confirmButtonText: 'Aceptar',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.href = './Inventario';
                        }
                    })
                }
                if (101 === dataResponse.status) {
                    return Swal.fire({
                        icon: 'error',
                        title: '¡Error!',
                        text: dataResponse.msj,
                        confirmButtonText: 'Aceptar',
                    })
                }
            })

    }

    async function handleBack() {
        props.edit()
    }

    return (
        <>
            {(infoUser.login === true) ? (
                (infoUser.role === 'SuperUsuario') ? (window.location.href = './Crear_Empresa') : (
                    <>
                        <div className="containerHeardANDTable">
                            <div className="HeardANDFilter">
                                <LogoComponent />
                                <div className='containerButtonAdd'>
                                    <div className="navigationContainer">
                                        <div className="pageTitle">CREAR INVENTARIO</div>
                                    </div>
                                </div>
                                <div className='closeIntContainer'>
                                    <CloseButton />
                                </div>
                            </div>
                        </div>
                        <div id='overallContainer' className='overallContainer'>
                            <Nav1 />
                            <div className='drawerFormAddCuotes'>
                                <form className='ContainerClient'>
                                    <div className='containerInfoEdit'>
                                        <div className='infoOneEdit'>
                                            <p className='personalInformationEdit'>AGREGAR INVENTARIO</p>
                                            <div className='containerNameClient'>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        value={name}
                                                        name="Name"
                                                        id="Name"
                                                        onChange={handleName}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Nombre del material <em className='Obligatory'>*</em> </label>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="number"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="quantity"
                                                        id="quantity"
                                                        className="inputCLient"
                                                        placeholder=" "
                                                        value={quantity}
                                                        disabled
                                                    />
                                                    <label htmlFor="name">Cantidad disponible<em className='Obligatory'>*</em> </label>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="text"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="typeOfMeasure"
                                                        id="typeOfMeasure"
                                                        value={typeOfMeasure}
                                                        onChange={handleTypeOfMeasure}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Tipo de medida <em className='Obligatory'>*</em> </label>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="number"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="pricePerMeasure"
                                                        id="pricePerMeasure"
                                                        value={pricePerMeasure}
                                                        onChange={handlePrecePerMeasure}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                    />
                                                    <label htmlFor="name">Precio por {typeOfMeasure ? typeOfMeasure : 'cantidad'} <em className='Obligatory'>*</em> </label>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="number"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="incoming"
                                                        id="incoming"
                                                        onChange={handleAmount}
                                                        onBlur={handleBlur}
                                                        className="inputCLient"
                                                        placeholder=" "
                                                        value={incomingQuantity}
                                                    />
                                                    <label htmlFor="name">Entrante o saliente <em className='Obligatory'>*</em> </label>
                                                </div>
                                                <div className="inputClientContainer">
                                                    <input
                                                        type="number"
                                                        onWheel={(e) => e.target.blur()}
                                                        name="Result"
                                                        id="Result"
                                                        className="inputCLient"
                                                        placeholder=" "
                                                        value={amount}
                                                        disabled
                                                    />
                                                    <label htmlFor="name">Rusultado <em className='Obligatory'>*</em> </label>
                                                </div>
                                            </div>
                                            <div className="buttonContainerAddClient">
                                                <NavLink className='Textregister' to="/Inventario" onClick={handleBack}><button className="button neon_Effect"><p>Atras</p></button></NavLink>
                                                <NavLink onClick={uploadInventory} className='Textregister'><button className="button neon_Effect"><p>Actualizar</p></button></NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </>
                )
            ) : (window.location.href = './Iniciar_Sesión')}
        </>
    )

}

export default EditInventory